
export default [
    {
        icon: 'home',
        text: 'base.home',
        link: { name: "home" },
        panel: false
    },
    {
        icon: 'inventory_2',
        text: 'menu.products',
        panel: false,
        children: [
            {
                icon: 'inventory_2',
                text: 'producto.menuTitle',
                link: { name: "ProductoManagementPage" },
                panel: false,
                permission: 'PRODUCTO_SHOW',
            },
            {
                icon: 'lightbulb',
                text: 'marca.menuTitle',
                link: { name: "MarcaManagementPage" },
                panel: false,
                permission: 'MARCA_SHOW'
            },
            {
                icon: 'label',
                text: 'modelo.menuTitle',
                link: { name: "ModeloManagementPage" },
                panel: false,
                permission: 'MODELO_SHOW',
            },
            {
                icon: 'straighten',
                text: 'tamanio.menuTitle',
                link: { name: "TamanioManagementPage" },
                panel: false,
                permission: 'TAMANIO_SHOW',
            },
            {
                icon: 'label',
                text: 'media.file.csvEtiquetas.title',
                link: { name: "CsvEtiquetasPage" },
                panel: false,
                permission: 'FILE_SHOW',
            },
            {
                icon: 'local_offer',
                text: 'oferta.menuTitle',
                link: { name: "OfertaManagementPage" },
                panel: false,
                permission: 'OFERTA_SHOW',
            },
            {
                icon: 'percent',
                text: 'recargo.menuTitle',
                link: { name: "RecargoManagementPage" },
                panel: false,
                permission: 'RECARGO_SHOW',
            },
            {
                icon: 'mdi-database-import',
                text: 'importarProductos.menuTitle',
                link: { name: "ImportarProductosPage" },
                panel: false,
                permission: 'PRODUCTO_IMPORTAR',
            },
            {
                icon: 'mdi-format-list-numbered',
                text: 'listaPreciosVenta.menuTitle',
                link: { name: "ListaPreciosVentaManagementPage" },
                panel: false,
                permission: 'LISTA_PRECIOS_VENTA_SHOW',
            },
        ]
    },
    {
        icon: 'shopping_cart',
        text: 'menu.purchases',
        panel: false,
        children: [
            {
                icon: 'local_shipping',
                text: 'proveedor.menuTitle',
                link: { name: "ProveedorManagementPage" },
                panel: false,
                permission: 'PROVEEDOR_SHOW',
            },
            {
                icon: 'mdi-cart-arrow-down',
                text: 'menu.ordenesCompra',
                link: { name: "OrdenCompraManagementPage" },
                panel: false,
                permission: 'COMPRAS_ORDEN_SHOW',
            },
            {
                icon: 'mdi-scale-balance',
                text: 'compararPreciosProveedor.menuTitle',
                link: { name: "CompararPreciosProveedorPage" },
                panel: false,
                permission: 'LISTA_PRECIOS_PROVEEDOR_IMPORTAR',
            },
            {
                icon: 'mdi-file-table',
                text: 'importarListaPrecios.menuTitle',
                link: { name: "ImportarListaPreciosPage" },
                panel: false,
                permission: 'LISTA_PRECIOS_PROVEEDOR_IMPORTAR',
            },
        ]
    },
    {
        icon: 'attach_money',
        text: 'menu.sales',
        panel: false,
        children: [
            {
                icon: 'attach_money',
                text: 'movimiento.menuTitle',
                link: { name: "MovimientoManagementPage" },
                panel: false,
                permission: 'MOVIMIENTO_SHOW',
            },
            {
                icon: 'mdi-file-document-outline',
                text: 'Presupuestos',
                link: { name: "PresupuestoManagementPage" },
                panel: false,
                permission: 'VENTAS_PRESUPUESTO_SHOW',
            },
            {
                icon: 'mdi-cart-check',
                text: 'Órdenes de venta',
                link: { name: "OrdenVentaManagementPage" },
                panel: false,
                permission: 'VENTAS_ORDEN_SHOW',
            },
            {
                icon: 'people',
                text: 'cliente.menuTitle',
                link: { name: "ClienteManagementPage" },
                panel: false,
                permission: 'CLIENTE_SHOW',
            },
            {
                icon: 'mdi-account-tie',
                text: 'Vendedores',
                link: { name: "VendedorManagementPage" },
                panel: false,
                permission: 'VENDEDOR_SHOW',
            },
        ]
    },
    {
        icon: 'settings',
        text: 'menu.adminConfig',
        panel: false,
        children: [
            {
                icon: 'receipt',
                text: 'facturacion.menuTitle',
                link: { name: "facturacion.facturas" },
                panel: false,
                permission: 'FACTURACION_FACTURA_SHOW',
            },
            // {
            //     icon: 'warehouse',
            //     text: 'deposito.menuTitle',
            //     link: { name: "DepositoManagementPage" },
            //     panel: false,
            //     permission: 'DEPOSITO_SHOW',
            // },
            {
                icon: 'history',
                text: 'registroActividad.menuTitle',
                link: { name: "RegistroActividadPage" },
                panel: false,
                permission: 'REGISTRO_ACTIVIDAD_SHOW',
            },
        ]
    },
    {
        icon: 'dashboard',
        text: 'menu.statistics',
        panel: false,
        permission: 'DASHBOARD_SHOW',
        children: [
            {
                icon: 'dashboard',
                text: 'dashboard.menuTitle',
                link: { name: "DashboardManagementPage" },
                panel: false,
                permission: 'DASHBOARD_SHOW',
            },
        ]
    },
    {
        icon: 'person',
        text: 'menu.administration',
        panel: false,
        permission: 'SECURITY_ADMIN_MENU',
        children: [
            {
                icon: 'assignment_ind',
                text: 'menu.userdashboard',
                link: { name: "userDashboard" },
                panel: false,
                permission: 'SECURITY_DASHBOARD_SHOW'
            },
            {
                icon: 'settings_applications',
                text: 'menu.customization',
                link: { name: "customization" },
                panel: false,
                permission: 'CUSTOMIZATION_SHOW'
            },
            {
                icon: 'assignment_ind',
                text: 'user.title',
                link: { name: "userManagement" },
                panel: false,
                permission: 'SECURITY_USER_SHOW'
            },
            {
                icon: 'verified_user',
                text: 'role.title',
                link: { name: "roleManagement" },
                panel: false,
                permission: 'SECURITY_ROLE_SHOW'
            },
            {
                icon: 'group',
                text: 'group.title',
                link: { name: "groupManagement" },
                panel: false,
                permission: 'SECURITY_GROUP_SHOW'
            },

        ]
    },
    // {
    //     icon: 'perm_phone_msg',
    //     text: 'base.about',
    //     link: { name: "about" },
    //     panel: false,
    // },
]
